<template>
  <BModalForm
    ref="modal"
    v-bind="$attrs"
    :data="parameter"
    :create-default-data="createDefaultData"
    :action-save="onSave"
    :action-delete="onDelete"
    max-width="600px"
    @closed="$emit('closed')"
  >
    <template #title-text="{ viewOnly, form }">
      {{ getTitle(viewOnly, form) }}
    </template>

    <template #default="{ form, viewOnly }">
      <BTextField
        v-model="form.display_name"
        :readonly="viewOnly"
        label="Наименование"
      />

      <BTextField
        v-model="form.report_name"
        :readonly="viewOnly"
        label="Наименование для отчета"
        class="mt-2"
      />

      <v-combobox
        v-model="form.variants"
        :readonly="viewOnly"
        :items="[1, 2, 3, 4, 5]"
        label="Варианты"
        outlined
        multiple
        dense
        chips
        small-chips
        deletable-chips
        class="mt-2"
      />
    </template>
  </BModalForm>
</template>

<script>
import { RoadmapBaseEventParameterModel as Model } from './Model'
import { RoadmapExpertsParametersApi } from '@/api/resources/Admin/Roadmap/Experts/Parameters'

import BTextField from '@/components/forms/BTextField.vue'
import BModalForm from '@/components/modals/BModalForm.vue'

export const createDefaultData = () => ({
  display_name: '',
  report_name: '',
  variants: [],
})

export default {
  name: 'RoadmapBaseEventsModal',
  components: {
    BModalForm,
    BTextField,
  },
  inheritAttrs: false,
  props: {
    criterionId: {
      type: [Number, String],
      required: true,
    },
    parameter: Object,
  },
  data: () => ({
    createDefaultData,
  }),
  methods: {
    open() {
      return this.$refs.modal.open()
    },
    close() {
      return this.$refs.modal.close()
    },
    async onDelete(body) {
      const api = new RoadmapExpertsParametersApi()
      await api.delete(body.id)
      this.$emit('created')
    },
    async onSave(body) {
      const api = new RoadmapExpertsParametersApi()
      if (body.id) {
        await api.update(body.id, {
          ...body,
          criterion_id: this.criterionId,
        })
      } else {
        await api.create({
          ...body,
          criterion_id: this.criterionId,
        })
      }
      this.$emit('created')
    },
    getTitle(viewOnly, form) {
      if (viewOnly) return Model.page_title.view(form)
      return form.id ? Model.page_title.edit : Model.page_title.create
    },
  },
}
</script>
